export const handleChangeInputVerificationPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_VERIFICATION', name, value
});


export const handleChangeTimerTimePageVerification = (timer_time) => ({
    type: 'CHANGE_TIMER_TIME_PAGE_VERIFICATION', timer_time
});

export const handleChangeLoaderPageVerification = (isLoading) => ({
    type: 'CHANGE_LOADER_PAGE_VERIFICATION', isLoading
});

export const handleChangeDisabledBtnPageVerification = (disabledBtn) => ({
    type: 'CHANGE_DISABLE_BTN_PAGE_VERIFICATION', disabledBtn
});


export const handleChangeBtnClassPageVerification = (className) => ({
    type: 'CHANGE_BTN_CLASS_PAGE_VERIFICATION', className
});